package com.bikompanion.ui.models

import com.bikompanion.domain.BikeVoteFailure
import com.bikompanion.ui.strings.BikompanionStrings

internal fun BikeRatingMessage.text(strings: BikompanionStrings): String =
    when (this) {
        BikeRatingMessage.NetworkRequired -> {
            strings.ratingNetworkRequired
        }

        is BikeRatingMessage.Thanks -> {
            strings.ratingThanks(bikeNumber)
        }

        is BikeRatingMessage.InCooldown -> {
            strings.ratingCooldown(retryAfterMinutes.toInt())
        }

        // Deliberately not phrased as success: the score on screen will not move until this
        // reaches the server, and saying "thanks" would imply it had.
        BikeRatingMessage.Queued -> {
            strings.ratingQueued
        }

        is BikeRatingMessage.Failed -> {
            when (reason) {
                BikeVoteFailure.InvalidBike -> strings.ratingInvalidBike
                BikeVoteFailure.Rejected -> strings.ratingRejected
            }
        }
    }
